"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatSDKError = exports.ChatSDKErrorName = void 0;
/**
 * Enum of ChatSDK standard errors.
 *
 * @enum {string}
 */
var ChatSDKErrorName;
(function (ChatSDKErrorName) {
    /** Failure in ChatAdapter initialization */
    ChatSDKErrorName["ChatAdapterInitializationFailure"] = "ChatAdapterInitializationFailure";
    /** Live Chat Version currently not supported with ChatSDK */
    ChatSDKErrorName["UnsupportedLiveChatVersion"] = "UnsupportedLiveChatVersion";
    /** Failure in OCSDK initialization */
    ChatSDKErrorName["OmnichannelClientInitializationFailure"] = "OmnichannelClientInitializationFailure";
    /** Failure in messaging/communication client creation */
    ChatSDKErrorName["MessagingClientCreationFailure"] = "MessagingClientCreationFailure";
    /** Failure in retrieval of ChatConfig */
    ChatSDKErrorName["ChatConfigRetrievalFailure"] = "ChatConfigRetrievalFailure";
    /** ChatSDK is not initialized */
    ChatSDKErrorName["UninitializedChatSDK"] = "UninitializedChatSDK";
    /** Failure in retrieving ChatToken */
    ChatSDKErrorName["ChatTokenRetrievalFailure"] = "ChatTokenRetrievalFailure";
    /** Failure in loading a script dynamically */
    ChatSDKErrorName["ScriptLoadFailure"] = "ScriptLoadFailure";
    /** Feature not supported in the platform used */
    ChatSDKErrorName["UnsupportedPlatform"] = "UnsupportedPlatform";
    /** Feature is not enabled. */
    ChatSDKErrorName["FeatureDisabled"] = "FeatureDisabled";
    /** Conversation has been closed (WrapUp/Closed state) */
    ChatSDKErrorName["ClosedConversation"] = "ClosedConversation";
    /** Conversation is invalid or not found */
    ChatSDKErrorName["InvalidConversation"] = "InvalidConversation";
    /** Failure in retrieval of the conversation given the authenticated user id */
    ChatSDKErrorName["AuthenticatedChatConversationRetrievalFailure"] = "AuthenticatedChatConversationRetrievalFailure";
    /** Failure on retrieving conversation from persistent chat */
    ChatSDKErrorName["PersistentChatConversationRetrievalFailure"] = "PersistentChatConversationRetrievalFailure";
    /** Failure on conversation init due to widget being outside of operating hours */
    ChatSDKErrorName["WidgetUseOutsideOperatingHour"] = "WidgetUseOutsideOperatingHour";
    /** Failure in conversation initialization */
    ChatSDKErrorName["ConversationInitializationFailure"] = "ConversationInitializationFailure";
    /** Failure in closure of the conversation */
    ChatSDKErrorName["ConversationClosureFailure"] = "ConversationClosureFailure";
    /** Failure in messaging/communication client initialization */
    ChatSDKErrorName["MessagingClientInitializationFailure"] = "MessagingClientInitializationFailure";
    /** Failure in message/communication client joining the conversation */
    ChatSDKErrorName["MessagingClientConversationJoinFailure"] = "MessagingClientConversationJoinFailure";
    /** Failure on retrieving live chat transcript of a conversation */
    ChatSDKErrorName["LiveChatTranscriptRetrievalFailure"] = "LiveChatTranscriptRetrievalFailure";
    /** Failure on retrieving conversation details */
    ChatSDKErrorName["ConversationDetailsRetrievalFailure"] = "ConversationDetailsRetrievalFailure";
    /** Failure on finding the contact id related to the auth code */
    ChatSDKErrorName["AuthContactIdNotFoundFailure"] = "AuthContactIdNotFoundFailure";
    /** AuthTokenProvider is not implemented */
    ChatSDKErrorName["GetAuthTokenNotFound"] = "GetAuthTokenNotFound";
    /** Failure on retrieving AuthToken from AuthTokenProvider */
    ChatSDKErrorName["GetAuthTokenFailed"] = "GetAuthTokenFailed";
    /** AuthToken is undefined */
    ChatSDKErrorName["UndefinedAuthToken"] = "UndefinedAuthToken";
    ChatSDKErrorName["UnknownAMSLoadState"] = "UnknownAMSLoadState";
})(ChatSDKErrorName = exports.ChatSDKErrorName || (exports.ChatSDKErrorName = {}));
var ChatSDKError = /** @class */ (function () {
    function ChatSDKError(message, httpResponseStatusCode) {
        this.message = message;
        this.httpResponseStatusCode = httpResponseStatusCode;
    }
    ChatSDKError.prototype.toString = function () {
        return this.message;
    };
    return ChatSDKError;
}());
exports.ChatSDKError = ChatSDKError;
//# sourceMappingURL=ChatSDKError.js.map